import { parseQueryParams } from '@/utils/parseQueryParams';
import { DeepLinkIntent, DeepLinkSource } from './deepLinkStore';

/**
 * Parse a native URL path
 * `path` can be a full URL or a relative pathname like `/npoDetail?npoId=123`
 * or `/purchaseShow?influencerCode=123`
 * @returns DeepLinkIntent or undefined
 */
export function parseNativeDeepLink(path: string): DeepLinkIntent | undefined {
  if (!path || path === '/' || path === '') return undefined;

  return buildIntent(path, 'native');
}

/**
 * Parse a native URL path with custom params
 * `path` can be a full URL or a relative pathname like `/npoDetail?npoId=123`
 * or `/purchaseShow?influencerCode=123`
 */
export function parseNativeDeepLinkWithParams(
  path: string,
  params: Record<string, string>
): DeepLinkIntent | undefined {
  if (!path || path === '/' || path === '') return undefined;

  const [pathname] = path.split('?');
  const parsedParams = parseQueryParams(path);
  return buildIntentWithParams(pathname, Object.keys(parsedParams).length > 0 ? parsedParams : params, 'native');
}

function buildIntent(rawValue: string, source: DeepLinkSource): DeepLinkIntent | undefined {
  // Strip query string to get the clean pathname
  const [pathname] = rawValue.split('?');

  if (!pathname?.length) return undefined;

  const params = parseQueryParams(rawValue);

  return {
    pathname,
    params: Object.keys(params).length > 0 ? params : undefined,
    source,
    timestamp: Date.now()
  };
}

function buildIntentWithParams(
  pathname: string,
  params: Record<string, string>,
  source: DeepLinkSource
): DeepLinkIntent | undefined {
  return {
    pathname,
    params,
    source,
    timestamp: Date.now()
  };
}
